
import styled from "styled-components";
import Dropdown from "react-bootstrap/Dropdown";
// Styled components

export const DropdownWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
`;

export const CustomToggle = styled.div`
  display: flex;
  align-items: center;
  ${'' /* width: 89px; */}
  // height: 20px;
  // padding: 0 5px;
  font-size: 16px;
  cursor: pointer;
  color: #BDBDBD;
  line-height:20px;
  width:100%;
  &::after {
    display: none !important;
  }
`;

export const CustomToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width:100%;
  justify-content:space-between;
  color: #184A61;
font-family: Lato;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 20px; /* 125% */

.icon{
  margin-right:8px;
  margin-left:16px;
}
  .dropdown-arrow{
    display:flex;
    justify-content:center;
    align-items:center;
    width:16px;
    height:16px;
  }
`;

export const CustomMenu = styled(Dropdown.Menu)`
  border: 1px solid #efefef !important;
  border-radius: 4px !important;
  padding: 0px !important;
  min-width: ${(props) => props.dropdownWidth || "136px"} !important;
  width: ${(props) => props.dropdownWidth || "136px"} !important;
  max-height: ${(props) => props.dropdownHeight || "144px"} !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
  position: absolute !important;
  top: ${({ isTop }) => isTop || "14px"} !important;
  right: ${({ isRight }) => isRight || "14px"} !important;
  z-index: 1050 !important;

  ::-webkit-scrollbar {
    width: 4px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #bdbdbd;
    border-radius: 4px;
  }

  ::-webkit-scrollbar-track {
    background-color: #ffffff;
    border-radius: 4px;
  }
`;

export const CustomDropdownItem = styled(Dropdown.Item)`
  font-family: "Lato" !important;
  font-size: 16px !important;
  padding: 14px 16px !important;
  border-radius: 4px !important;
  font-weight: 400;
  line-height: 20px;
  color: ${({ active }) => (active ? "white" : "#184A61")} !important;
  background-color: ${({ active }) =>
    active ? "#DA6C74" : "transparent"} !important;

  &:hover {
    border-radius: 4px !important;
    color: white !important;
    background-color:#DA6C74 !important;
  }
`;

